import React, { useState } from "react";
import { ChevronDown, ChevronUp, Info } from "lucide-react";
import { MODULE_DESCRIPTIONS } from "../lib/moduleDescriptions";

// Elenco moduli raggruppato per area, condiviso fra onboarding (passo "Servizio e moduli")
// e scheda azienda (tab "Servizio & moduli"): per ogni gruppo "Seleziona/Deseleziona tutti",
// per ogni modulo una sintesi e un'area "Apri spiegazione" con il dettaglio.
export default function ModuleSelector({ modules, value, onToggle, onSetMany, testIdPrefix = "module-toggle" }) {
  const [openKey, setOpenKey] = useState(null);
  const groups = [];
  modules.forEach((module) => {
    let group = groups.find(([name]) => name === module.group);
    if (!group) { group = [module.group, []]; groups.push(group); }
    group[1].push(module);
  });

  return (
    <div className="space-y-4">
      {groups.map(([group, items]) => {
        const activeCount = items.filter((m) => value[m.key]).length;
        const allActive = activeCount === items.length;
        return (
          <section key={group} className="rounded-xl border border-hairline bg-white p-4" aria-label={`Moduli ${group}`}>
            <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
              <div>
                <h4 className="font-heading font-semibold uppercase tracking-wide text-navy">{group}</h4>
                <p className="text-xs text-slate-400">{activeCount} di {items.length} attivi</p>
              </div>
              <div className="flex items-center gap-2 text-xs">
                <button type="button" disabled={allActive} className="min-h-[36px] rounded-md px-2 font-medium text-emerald-700 hover:underline disabled:text-slate-300 disabled:no-underline" onClick={() => onSetMany(items.map((m) => m.key), true)}>Seleziona tutti</button>
                <span className="text-slate-300">·</span>
                <button type="button" disabled={activeCount === 0} className="min-h-[36px] rounded-md px-2 font-medium text-slate-500 hover:underline disabled:text-slate-300 disabled:no-underline" onClick={() => onSetMany(items.map((m) => m.key), false)}>Deseleziona tutti</button>
              </div>
            </div>
            <div className="grid gap-2 sm:grid-cols-2">
              {items.map((module) => {
                const info = MODULE_DESCRIPTIONS[module.key];
                const open = openKey === module.key;
                const checked = Boolean(value[module.key]);
                return (
                  <div key={module.key} className={`rounded-lg border transition-colors ${checked ? "border-emerald-300 bg-emerald-50" : "border-hairline bg-white"} ${open ? "sm:col-span-2" : ""}`}>
                    <label className="flex cursor-pointer items-start gap-3 p-3">
                      <input type="checkbox" checked={checked} onChange={() => onToggle(module.key)} className="mt-0.5 h-5 w-5 shrink-0 accent-emerald-600" data-testid={`${testIdPrefix}-${module.key}`} />
                      <span className="min-w-0 flex-1">
                        <span className="block text-sm font-medium text-navy">{module.label}</span>
                        {module.badge && <span className="block text-xs text-slate-400">{module.badge}</span>}
                        {info?.summary && <span className="mt-1 block text-xs leading-relaxed text-slate-600">{info.summary}</span>}
                        {info?.notYetActive && <span className="mt-1 inline-block rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-medium text-amber-800">Predisposto: non ancora attivo nell’app</span>}
                      </span>
                    </label>
                    {info?.details?.length > 0 && (
                      <div className="px-3 pb-3">
                        <button type="button" onClick={() => setOpenKey(open ? null : module.key)} aria-expanded={open} aria-controls={`module-info-${module.key}`}
                          className="inline-flex min-h-[36px] items-center gap-1.5 rounded-md text-xs font-medium text-navy underline-offset-4 hover:underline" data-testid={`module-info-${module.key}`}>
                          <Info className="h-3.5 w-3.5" /> {open ? "Chiudi spiegazione" : "Apri spiegazione"} {open ? <ChevronUp className="h-3.5 w-3.5" /> : <ChevronDown className="h-3.5 w-3.5" />}
                        </button>
                        {open && (
                          <div id={`module-info-${module.key}`} className="mt-2 rounded-lg border border-blue-200 bg-blue-50/60 p-4 text-sm text-slate-700">
                            <p className="mb-2 font-semibold text-navy">Cosa permette di fare</p>
                            <ul className="list-disc space-y-1 pl-5">
                              {info.details.map((line) => <li key={line}>{line}</li>)}
                            </ul>
                            {info.where && <p className="mt-3 text-xs text-slate-500"><strong>Dove lo trova il cliente:</strong> {info.where}</p>}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </section>
        );
      })}
    </div>
  );
}
